<template>
  <div>
    <h4>{{LangSelected.Interno.Principal}}</h4>
  </div>
</template>
<script>
export default{
  data(){
    return{
      LangSelected:JSON.parse(localStorage.getItem('languageInfo')),
    };
  },
}
</script>

